import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts?.pdfMake?.vfs;

import getDocDefinition from "./docDefinition";

function printDoc(printParams, gridApi, columnApi) {
  console.log("Exporting to PDF...");
  const docDefinition = getDocDefinition(printParams, gridApi, columnApi);
  //pdfMake.createPdf(docDefinition).download(printParams.PDF_FILENAME);
  //pdfMake.createPdf(docDefinition).open();

  pdfMake.createPdf(docDefinition).getBlob((blob) => {
    // Create an object URL for the PDF
    const url = URL.createObjectURL(blob);

    // Open the PDF in a new window
    window.open(url);
  });
}

export default printDoc;
